/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { Customer, CustomerConsent } from "../types/Entities/Customer";

const isValidDateString = (s: unknown): s is string => typeof s === "string" && s.trim() !== "" && !Number.isNaN(Date.parse(s));

export function customerHasConsent(customer: Customer, consent: string): boolean {
  return (customer?.consents ?? []).some(
    (c) => c?.type === consent && isValidDateString(c?.approvalDate) && (c?.denialDate == null || String(c.denialDate).trim() === "")
  );
}

export function getCustomerConsent(customer: Customer, type: string): CustomerConsent | null {
  return (customer?.consents ?? []).find((c) => c?.type === type) ?? null;
}
